//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'setChartConf-editor',
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  }
};